import React from 'react';
import { Link } from 'react-router-dom';

type LinkWrapperProps = {
  children: React.ReactNode;
  url: string;
  className?: string;
  target?: '_self' | '_blank';
};

const LinkWrapper = ({ children, url, className = '', target = '_self' }: LinkWrapperProps) => (
  <Link to={url} className={className} target={target}>{children}</Link>
);

export default LinkWrapper;
